
import { Component, Vue, toNative, Prop } from 'vue-facing-decorator';

@Component
class SuggestionBox extends Vue {
  @Prop() private showSuggestionBox!: boolean;
  @Prop() private suggestions!: string[];
  @Prop() private highlightedIndex!: number;

  private SelectItem(item: string) {
    this.$emit('item-selected', item);
  }
}

export default toNative(SuggestionBox);
